export default "__VITE_ASSET__CoL2zPqK__"